module.exports = __webpack_public_path__ + "img/icon_line2.bf98e30d.png";